import { getFleetStatus } from "@/api/asset-api.js";
import { changeSessionTenant as changeSessionTenantApi } from "@/api/detechtion-account-api.js";
import { isRequestAborted } from "@/api/api-utils.js";

/**
 * Confirms fleet-status accepts the current session (auth refresh allowed).
 * Re-syncs tenant via ChangeSessionTenant once on 401, then retries fleet-status.
 * @param {number} tenantId
 * @returns {Promise<unknown>} fleet-status response body
 */
export async function ensureFleetReady(tenantId) {
  try {
    return await getFleetStatus();
  } catch (err) {
    if (isRequestAborted(err)) throw err;
    if (err?.response?.status !== 401) throw err;
    await changeSessionTenantApi(tenantId);
    return await getFleetStatus();
  }
}
